export interface ContactQuery {
  name: string;
  phoneNumber: string;
  emailAddress: string;
  roomexReference: string;
  query: string;
  enquiryType: EnquiryType;
}

export enum EnquiryType {
  Booking = 1,
  General,
}
